import { TaskStatus } from "../enums/task-status.enum";

export const getTaskStatusLabel = (status: TaskStatus) => {
  switch (status) {
    case TaskStatus.TODO:
      return "Todo";
    case TaskStatus.IN_PROGRESS:
      return "In Progress";
    case TaskStatus.DONE:
      return "Done";
    case TaskStatus.REVIEW:
      return "Review";
    case TaskStatus.POSTPONED:
      return "Postponed";
    default:
      return "Unknown";
  }
};

export const getTaskStatusContainerBgColor = (status: TaskStatus) => {
  return status === TaskStatus.TODO
    ? "rgba(44, 82, 140, 0.4)"
    : status === TaskStatus.IN_PROGRESS
    ? "rgba(181, 109, 0, 0.4)"
    : status === TaskStatus.DONE
    ? "rgba(57, 140, 44, 0.4)"
    : status === TaskStatus.POSTPONED
    ? "rgba(169, 107, 227, 0.4)"
    : status === TaskStatus.REVIEW
    ? "rgba(140, 44, 44, 0.4)"
    : "transparent";
};

export const getTaskStatusContainerTextColor = (status: TaskStatus) => {
  return status === TaskStatus.TODO
    ? "#2C528C"
    : status === TaskStatus.IN_PROGRESS
    ? "#B56D00"
    : status === TaskStatus.DONE
    ? "#398C2C"
    : status === TaskStatus.POSTPONED
    ? "#a96be3"
    : status === TaskStatus.REVIEW
    ? "#8C2C2C"
    : "black";
};
